<script lang="ts">
  import { type POI } from "../poi";

  export let poi: POI | undefined;
</script>

<div class="route-node">
  <label><slot name="title"></slot></label>
  <div class="poi" class:missing={!poi}>
    {#if poi}
      <strong class="poi-label">{poi.label}</strong>
      <span>{poi.floor}</span>
    {:else}
      <slot name="hint"></slot>
    {/if}
  </div>
</div>

<style>
  .route-node {
    margin-bottom: 1rem;
  }

  label {
    display: block;
    font-size: inherit;
    text-transform: uppercase;
  }

  .poi {
    padding: var(--_p1);
    border: 2px salmon solid;
  }

  .poi-label {
    display: block;
  }

  .poi.missing {
    background: var(--_bg-2nd);
    border: 2px salmon dashed;
    font-style: italic;
  }
</style>